import React, { Fragment } from "react";
import { Seo, Breadcrumb, ScrollTopBtn } from "../components";
import { HeaderThree, NotFoundOne, FooterTwo } from "../containers";

const NotFound = () => (
  <Fragment>
    <Seo
      title="Page Not Found - Tech Ayukta"
      description="The page you are looking for does not exist or has been moved. Return to Tech Ayukta’s homepage or explore our services."
      keywords="404 Error, Page Not Found, Tech Ayukta"
      canonical="https://www.techayukta.com/404"
    />

    <HeaderThree />
    <Breadcrumb
      pageName="Error Page"
      bgImage="/images/breadcumb/breadcumb-bg.jpg"
    />
    <NotFoundOne />
    <FooterTwo />
    <ScrollTopBtn />
  </Fragment>
);

export default NotFound;
